import { getArchivedTrend } from "../app/api/archive";
import store from "../app/store";
import { setArchivedTrends } from "../app/slices/trendSlice";
import { getArchivedTrendNames } from "./archivedTrends";
import { MAX_TRENDS_SIZE } from "../constants/constants";
import { User } from "../types";

/**
 * Fetches the current archived-trend list from the backend,
 * syncs it into Redux `archivedTrends`, and returns the result.
 *
 * Call this **before** dispatching `bumpTrendCurveRefresh` /
 * `invalidateGraphCache` so that the graphRevision-triggered
 * refetches always see the up-to-date archived set.
 */
export const refreshArchivedTrends = async (
  user: User | null,
  reqId: string
): Promise<{ names: string[]; trends: unknown[] }> => {
  try {
    const response = await getArchivedTrend(
      {
        req_id: reqId,
        posts_per_trend: 1,
        page: 1,
        pageSize: MAX_TRENDS_SIZE,
      },
      user
    );
    const trends = Array.isArray(response?.data?.trends)
      ? response?.data?.trends
      : [];
    const names = getArchivedTrendNames(trends);
    store.dispatch(setArchivedTrends(names));
    return { names, trends };
  } catch {
    return {
      names: store.getState().trends.archivedTrends,
      trends: [],
    };
  }
};
